import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { TextButton } from '../../shared/text-button/text-button';
import { Alert } from '../../shared/alert/alert';

export interface IT2CPendingAlertProps {
  openResendInviteModal: () => void;
}

export const T2CPendingAlert = ({
  openResendInviteModal,
}: IT2CPendingAlertProps) => {
  return (
    <Alert status="info">
      <Typography variant="body-base">
        Text2Confirm Invite Pending Acceptance
      </Typography>
      <TextButton className="sui-mt-4" onClick={openResendInviteModal}>
        Resend Invite
      </TextButton>
    </Alert>
  );
};
